<template>
  <MetaInfo :title="meta.title" :description="meta.description"></MetaInfo>

  <div class="blog-page">
    <navigation></navigation>

    <PageHeader title="Insights, tips & announcements"></PageHeader>

    <div class="container-fluid blog__content" v-if="dataLoaded === true">
      <div class="row">
        <div class="col-xs-12">
          <div class="blog__layout">
            <div class="blog__filters" ref="filters">
              <label class="blog__filters-title" for="blog-search">Search</label>
              <div class="blog__search">
                <svg class="blog__search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/></svg>
                <input
                  id="blog-search"
                  class="blog__search-input"
                  type="search"
                  v-model="searchQuery"
                  placeholder="Search articles"
                  autocomplete="off"
                />
              </div>

              <span class="blog__filters-title">Filter by tag</span>
              <ul class="blog__filters-list">
                <li>
                  <button
                    type="button"
                    class="blog__filters-item"
                    v-bind:class="{ 'blog__filters-item--active': activeTag === null }"
                    v-on:click="setTag(null)"
                  >
                    All
                  </button>
                </li>
                <li v-for="tag in tags" v-bind:key="tag">
                  <button
                    type="button"
                    class="blog__filters-item"
                    v-bind:class="{ 'blog__filters-item--active': activeTag === tag }"
                    v-on:click="setTag(tag)"
                  >
                    {{ tag }}
                  </button>
                </li>
              </ul>
            </div>

            <div class="blog__main">
              <blog-promo-banner></blog-promo-banner>

              <div class="blog__grid">
                <blog-article
                  v-for="article in filteredBlogData"
                  v-bind:key="article.id"
                  v-bind:blogData="article"
                ></blog-article>
                <p class="blog__empty" v-if="filteredBlogData.length === 0">
                  No articles match<span v-if="searchQuery.trim()"> “{{ searchQuery.trim() }}”</span>.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <site-footer></site-footer>
  </div>
</template>

<script>
import MetaInfo from "@/components/MetaInfo";
import Navigation from "@/components/navigation/Main";
import SiteFooter from "@/components/Blog/BlogFooter";
import PageHeader from "@/components/Header/PageHeader";
import BlogArticle from "@/components/Blog/BlogArticleUpNextListing";
import BlogCategories from "@/functions/blogCategories";
import BlogPromoBanner from "@/components/Blog/BlogPromoBanner";
import axios from "axios";

export default {
  name: "BlogPage",
  components: {
    MetaInfo,
    Navigation,
    PageHeader,
    SiteFooter,
    BlogArticle,
    BlogPromoBanner,
  },
  data() {
    return {
      blogData: [],
      featuredBlogData: {},
      dataLoaded: false,
      activeTag: null,
      searchQuery: "",
      meta: {
        title: "Transpond blog",
        description:
          "Get the latest updates from the Transpond team, and take your  marketing experience even further.",
      },
    };
  },
  computed: {
    tags() {
      return BlogCategories.list(this.blogData);
    },
    filteredBlogData() {
      const query = this.searchQuery.trim().toLowerCase();

      return this.blogData.filter((article) => {
        if (this.activeTag && !BlogCategories.hasTag(article, this.activeTag)) {
          return false;
        }

        if (!query) {
          return true;
        }

        return this.articleSearchText(article).includes(query);
      });
    },
  },
  created() {
    axios.get("https://api.transpond.io/api/blog").then((response) => {
      this.featuredBlogData = response.data.Blogs[0];
      this.blogData = response.data.Blogs;
      this.dataLoaded = true;
      this.$nextTick(() => this.fitCategoryScroll());
    });
  },
  mounted() {
    this.fitCategoryScroll();
    this._onFitCategories = () => this.fitCategoryScroll();
    window.addEventListener("resize", this._onFitCategories, { passive: true });
    window.addEventListener("scroll", this._onFitCategories, { passive: true });
  },
  beforeUnmount() {
    window.removeEventListener("resize", this._onFitCategories);
    window.removeEventListener("scroll", this._onFitCategories);
    if (this._fitFrame) cancelAnimationFrame(this._fitFrame);
  },
  methods: {
    fitCategoryScroll() {
      if (this._fitFrame) return;
      this._fitFrame = requestAnimationFrame(() => {
        this._fitFrame = null;
        const filters = this.$refs.filters;
        if (!filters) return;
        const desktop = window.matchMedia("(min-width: 768px)").matches;
        if (!desktop) {
          filters.style.maxHeight = "";
          return;
        }
        const stickyTop = parseFloat(getComputedStyle(filters).top) || 0;
        const top = Math.max(filters.getBoundingClientRect().top, stickyTop);
        filters.style.maxHeight = Math.max(0, window.innerHeight - top) + "px";
      });
    },
    articleSearchText(article) {
      const parts = [article && article.blogTitle];

      if (article && article.meta && article.meta.description) {
        parts.push(article.meta.description);
      }

      if (article && article.linkDescription) {
        parts.push(article.linkDescription);
      }

      return parts.filter(Boolean).join(" ").toLowerCase();
    },
    setTag(tag) {
      this.activeTag = this.activeTag === tag ? null : tag;
      this.$nextTick(() => {
        const grid = this.$el.querySelector(".blog__grid");
        if (!grid) return;
        const offset = 96;
        const top = grid.getBoundingClientRect().top;
        if (top < offset) {
          window.scrollTo({
            top: window.scrollY + top - offset,
            behavior: "smooth",
          });
        }
        this.fitCategoryScroll();
      });
    },
  },
};
</script>
